Namespace 'Monitoring.Models.SocialContents.LinkedIn'

class Monitoring.Models.SocialContents.LinkedIn.LinkedInComment
  constructor: (linkedInCommentBuilder) ->
    @parentPostId = linkedInCommentBuilder.getParentPostId()
    @parentCommentId = linkedInCommentBuilder.getParentCommentId()
    @text = linkedInCommentBuilder.getText()
    @createdAt = linkedInCommentBuilder.getCreatedAt()
    @contentId = linkedInCommentBuilder.getContentId()
    @isBrandContent = linkedInCommentBuilder.getIsBrandContent()

  getParentPostId: ->
    @parentPostId

  getParentCommentId: ->
    @parentCommentId

  getText: ->
    @text

  getCreatedAt: ->
    @createdAt

  getContentId: ->
    @contentId

  getIsBrandContent: ->
    @isBrandContent
